import { Box, Button, Flex, HStack, Link, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { FaChrome } from "react-icons/fa6";
import { MdCalendarToday } from "react-icons/md";
import { BuyerInterface } from "../../Interface/CommonInterface";
import { relevanceFields } from "../../Constants/data";

// Claude: extracted from BuyersList.tsx 23-03-2026
interface Props {
  item: any;
  accordionActive: string;
  setAccordionActive: (v: string) => void;
  buyers: BuyerInterface[];
  buyerCompanyListItemClick: (companyName: string) => void;
  setRelevanceData: (v: any) => void;
  handleOpenRelevanceModal: () => void;
  meetingData: any;
  sellerData: any;
  user: any;
  userPlan: any;
  setNotesData: React.Dispatch<React.SetStateAction<any>>;
  handleOpenNotesModal: () => void;
  handleOpenMeetModal: () => void;
  setMeetResponder: (v: any) => void;
  handleOpenMeetConfirmModal: () => void;
  setCurrentMeet: (v: string) => void;
  isNewMeetingAllowed: (status: string) => boolean;
  error: (msg: string) => void;
}

const BuyerCompanyCard = ({
  item, accordionActive, setAccordionActive, buyers, buyerCompanyListItemClick,
  setRelevanceData, handleOpenRelevanceModal, meetingData, sellerData, user, userPlan,
  setNotesData, handleOpenNotesModal, handleOpenMeetModal, setMeetResponder,
  handleOpenMeetConfirmModal, setCurrentMeet, isNewMeetingAllowed, error,
}: Props) => (
  <Box
    p={"15px"}
    cursor={"pointer"}
    _hover={{ shadow: "md", bg: "#D7F5D3" }}
    border={"1px solid #E2E8F0"}
    borderRadius={"15px"}
    shadow={"sm"}
    bg={accordionActive == item?.companyName ? "white" : "transparent"}
    onClick={() => {
      if (accordionActive == item?.companyName) {
        setAccordionActive("");
      } else {
        setAccordionActive(item?.companyName);
        buyerCompanyListItemClick(item.companyName);
      }
    }}
  >
    <Flex justifyContent={"space-between"} alignItems={"center"}>
      <Text fontSize={"sm"} fontWeight={"medium"}>
        {item.companyName}
      </Text>
      <Box
        height={18}
        width={18}
        borderRadius={"2px"}
        background={relevanceFields.find((s) => s.status === item.prequalificationStatus)?.color}
        onClick={(e: any) => {
          e.stopPropagation();
          handleOpenRelevanceModal();
          setRelevanceData({
            prequalified_company_name: item.companyName,
            prequalified_user_id: item.buyers.map((i: any) => i.buyerId),
            event_id: item.eventId,
            status: item.prequalificationStatus,
          });
        }}
      />
    </Flex>

    <Box
      mt={3}
      overflow={accordionActive == item.companyName ? "visible" : "hidden"}
      opacity={accordionActive == item.companyName ? 1 : 0}
      height={accordionActive == item.companyName ? "auto" : "0px"}
      transition={"all 0.5s ease-in-out"}
    >
      <VStack w={"100%"} spacing={4}>
        {[...buyers].map((buyer: any, index: number) => (
          <Box key={"buyer_" + index} w={"100%"} cursor={"default"}>
            <HStack justifyContent={"space-between"}>
              <Box>
                <Text fontSize={"sm"} fontWeight={"medium"} mb={"8px"}>
                  {buyer?.buyerPersonName}
                </Text>
                <Flex mb={"6px"}>
                  <Text fontSize={"small"} fontWeight={"light"}>
                    {buyer?.buyerDesignation}
                  </Text>
                </Flex>
                <Flex mb={"6px"}>
                  <Text fontSize={"small"} fontWeight={"light"}>
                    {buyer?.buyerCompanyInfo}
                  </Text>
                </Flex>
                {/* Claude: Company Type badges 14-04-2026 */}
                {buyer?.buyerCompanyType?.length > 0 && (
                  <Flex gap={1} mb={"6px"} flexWrap={"wrap"} alignItems={"center"}>
                    <Text fontSize={"small"} fontWeight={"medium"} whiteSpace={"nowrap"}>Type:</Text>
                    {buyer.buyerCompanyType.map((t: string, i: number) => (
                      <span key={i} style={{ padding: "2px 7px", backgroundColor: "#E3F2FD", color: "#1565C0", borderRadius: "3px", fontSize: "10px" }}>
                        {t === "Others" && buyer.buyerCompanyTypeOther ? buyer.buyerCompanyTypeOther : t}
                      </span>
                    ))}
                  </Flex>
                )}
                <Flex mb={"6px"}>
                  {buyer?.buyerPersonCity && buyer?.buyerPersonCountry && (
                    <Text fontSize={"small"} fontWeight={"light"}>
                      {`${buyer?.buyerPersonCity}, ${buyer?.buyerPersonCountry}`}
                    </Text>
                  )}
                </Flex>
                <Flex>
                  <Text fontSize={"small"} fontWeight={"medium"}>Notes : </Text>
                  <Link
                    color={"card.borderBlue"}
                    onClick={() => {
                      handleOpenNotesModal();
                      setNotesData((prev: any) => ({
                        ...prev,
                        forUser: buyer?._id,
                        companyName: buyer?.buyerCompanyName,
                      }));
                    }}
                  >
                    <Text color={"card.borderBlue"} fontSize={"xs"}>&nbsp; View/Add</Text>
                  </Link>
                </Flex>
              </Box>

              <Flex>
                <VStack>
                  <Button
                    colorScheme="transparent"
                    onClick={() => {
                      if (!sellerData.personPhoneNumber)
                        return error("Please provide your contact number in the profile page");
                      if (meetingData[buyer?.buyerCompanyName]) {
                        const meetingObj = meetingData[buyer?.buyerCompanyName];
                        if (isNewMeetingAllowed(user.user === meetingObj.requesterId ? meetingObj.requesterStatus : meetingObj.responderStatus)) {
                          handleOpenMeetModal();
                          setMeetResponder(buyer);
                        } else {
                          handleOpenMeetConfirmModal();
                          setCurrentMeet(meetingObj._id);
                        }
                      } else {
                        handleOpenMeetModal();
                        setMeetResponder(buyer);
                      }
                    }}
                  >
                    <MdCalendarToday size={22} color={"#F5793D"} />
                  </Button>
                  <Text fontWeight={"regular"} fontSize={"xs"}>Meet</Text>
                </VStack>

                {buyer?.buyerCompanyWebsite && (
                  <VStack>
                    <Button colorScheme="transparent" onClick={() => window.open(buyer?.buyerCompanyWebsite, "_blank")}>
                      <span><FaChrome size={22} color={"#F5793D"} /></span>
                    </Button>
                    <Text fontWeight={"regular"} fontSize={"xs"}>Site</Text>
                  </VStack>
                )}
              </Flex>
            </HStack>
          </Box>
        ))}
      </VStack>
    </Box>
  </Box>
);

export default BuyerCompanyCard;
